var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#626362;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.6,101.5l-23-23c-0.6-0.7-1.1-1.6-1.1-2.5V19.8c0-2.7-2.3-5-5-5h-33.8c-2.7,0-5,2.3-5,5v5.3 c0,1.4-0.9,2.7-2.2,3.2c-1.4,0.6-2.9,0.3-3.9-0.7L93.5,16.5c-1.8-1.8-5.1-1.8-6.9,0L1.5,101.5c-2,1.9-2,5.1,0,6.9 c1.9,1.8,5.1,1.8,7,0l11-11c0.6-0.6,1.6-1.1,2.5-1.1c0.5,0,0.9,0.1,1.4,0.3c1.4,0.5,2.2,1.8,2.2,3.2v60.3c0,2.7,2.3,5,5,5h119.1 c2.7,0,5-2.3,5-5V99.8c0-1.4,0.9-2.7,2.2-3.2c1.4-0.6,2.9-0.3,3.9,0.7l11,11c1.9,1.9,5.1,1.9,6.9,0 C180.5,106.5,180.5,103.4,178.6,101.5 M144.6,151.8c0,2-1.6,3.5-3.6,3.5h-16.9c-2,0-3.5-1.6-3.5-3.5v-35.3c0-5.1-4.1-9.2-9.2-9.2 c-5.1,0-9.2,4.1-9.2,9.2v35.3c0,2-1.6,3.5-3.5,3.5H39c-2,0-3.5-1.6-3.5-3.5V83.9c-0.1-1,0.2-2.5,0.9-3.2l51.2-51.2 c1.4-1.4,3.7-1.4,5.1,0l51.1,51c0.6,0.7,1.1,1.5,1.1,2.5v68.8H144.6z M144.6,58.9c0,1.4-0.9,2.7-2.3,3.2c-0.5,0.2-0.9,0.3-1.4,0.3 c-0.9,0-1.8-0.4-2.5-1l-17-17c-0.7-0.7-1.1-1.8-1-2.9c0.1-0.2,0.2-0.8,0.3-1V28.4c0-2,1.6-3.6,3.5-3.6h16.8c2,0,3.6,1.6,3.6,3.6 L144.6,58.9L144.6,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3,101.7H63.6c-4,0-7.2,3.2-7.2,7.2s3.2,7.2,7.2,7.2h16.7c4,0,7.2-3.2,7.2-7.2 C87.5,104.9,84.3,101.7,80.3,101.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/residential.46dac02e49c30fa52647087df441d11b.svg";
export { ForwardRef as ReactComponent };